/**
 * In-run pause menu (overlay) — resume, settings, abandon. Reached via Esc /
 * the MENU button on the map. Abandon records the run + returns to title.
 */

import { el, div, button } from "../dom";
import type { Store } from "../store";

export function renderMapMenu(store: Store): HTMLElement {
  const overlay = div("overlay");
  const modal = div("modal");
  modal.style.maxWidth = "360px";

  modal.appendChild(el("div", { class: "h-title center", text: "PAUSED" }));
  modal.appendChild(
    button("btn btn--primary btn--wide", "▶ RESUME", () =>
      store.closeOverlay(),
    ),
  );
  modal.appendChild(
    button("btn btn--wide", "▤ VIEW DECK", () => store.open("deck")),
  );
  modal.appendChild(
    button("btn btn--wide", "⚙ SETTINGS", () => store.open("settings")),
  );
  modal.appendChild(
    button("btn btn--wide btn--danger", "⌦ ABANDON RUN", () => {
      if (confirm("Abandon this run? Progress on this run is lost.")) {
        store.abandonRun();
      }
    }),
  );
  modal.appendChild(
    el("div", {
      class: "muted center",
      text: "Your run autosaves continuously — you can quit any time and Continue.",
      style: "white-space:normal;line-height:1.4",
    }),
  );

  overlay.appendChild(modal);
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) store.closeOverlay();
  });
  return overlay;
}
